import maplibregl from 'maplibre-gl';
import { CameraOptions, ExportOptions, Margin } from "../../types";
import { BBox } from 'geojson';
import { toByteLabel, toFeatures, toSvg } from '../../lib/mapDownload/turfFunc';


const getCamera = (map: maplibregl.Map): CameraOptions => {
    return {
        center: map.getCenter(),
        zoom: map.getZoom(),
        pitch: map.getPitch(),
        bearing: map.getBearing(),
    }
}

/* *******************
 * {[key: string]: string} のオブジェクトをtableに変換する関数
 * *******************/
export const createTableHTML = (featureAttribute: {[key: string]: string}): string => {
    let tableHTML = '<table border="1" style="border-collapse: collapse;">';
    for (const key in featureAttribute) {
        if (Object.prototype.hasOwnProperty.call(featureAttribute, key)) {
            const value = featureAttribute[key];
            if (Array.isArray(value) && Array.isArray(value[0])) {
                // 2次元配列の場合
                tableHTML += `<tr><th style="padding: 5px;">${key}</th><td><div class='table'>`;
                let counter = 0;
                // データ行を生成
                value.forEach(subArray => {
                    tableHTML += `<div class=${counter === 0 ? 'header' : 'row'}>`;
                    subArray.forEach((subValue: string) => {
                        tableHTML += `<div class='cell'>${subValue}</div>`;
                    });
                    tableHTML += `</div>`;
                    counter++;
                });
                tableHTML += `</div></td></tr>`;
            } else {
                // それ以外の場合
                tableHTML += `<tr><th style="padding: 5px;">${key}</th><td style="padding: 5px;">${value}</td></tr>`;
            }
        }
    }
    tableHTML += '</table>';
    return tableHTML;
};


/* *******************
  * 指定範囲のmapをsvgに変換する関数 
  * 引数
  *   map: maplibregl.Map
  *   bbox: BBox
  * *******************/
export const bbox2svg = async (map: maplibregl.Map, bbox: BBox) => {
    const features = await toFeatures(map, bbox);
    
    const { xml: svgString, width, height } = await toSvg(map, features, bbox);
    const blob = new Blob([svgString], { type: 'image/svg+xml' });
    const url = URL.createObjectURL(blob);
    const size = toByteLabel(blob.size);

    return { svg: blob, url, size, width, height };
}

/* *********************
 * marginからexportオプションに変換
 * *********************/
export const margin2exportOptions = (margin: Margin, map: maplibregl.Map, aspectRatio: number): ExportOptions | null => {
    if (margin) {
        const clientRect = map.getContainer().getBoundingClientRect()
        const left = margin.horizontal
        const top = margin.vertical
        const right = clientRect.right - clientRect.left - margin.horizontal
        const bottom = clientRect.bottom - clientRect.top - margin.vertical
        const leftTopPoint = new maplibregl.Point(left, top)
        const rightTopPoint = new maplibregl.Point(right, top)
        const rightBottomPoint = new maplibregl.Point(right, bottom)
        const leftBottomPoint = new maplibregl.Point(left, bottom)
        const leftTopLngLat = map.unproject(leftTopPoint).toArray() as [
            lng: number,
            lat: number
        ]
        const rightTopLngLat = map.unproject(rightTopPoint).toArray() as [
            lng: number,
            lat: number
        ]
        const rightBottomLngLat = map.unproject(rightBottomPoint).toArray() as [
            lng: number,
            lat: number
        ]
        const leftBottomLngLat = map.unproject(leftBottomPoint).toArray() as [
            lng: number,
            lat: number
        ]
        return {
            mapRect: [
                leftTopLngLat,
                rightTopLngLat,
                rightBottomLngLat,
                leftBottomLngLat,
            ],
            aspectRatio,
            cameraOptions: getCamera(map),
            containerSize: {
                outerWidth: clientRect.width,
                outerHeight: clientRect.height,
                margin,
            },
        }
    } else {
        return null
    }
}
